import { defineStore } from 'pinia'
import { appConfig } from '@/configs/appConfig.js'
import { i18n } from '@/i18n/index.js'

export const useLanguageStore = defineStore('language', {
  state: () => ({
    currentLocale: appConfig.defaultLocale
  }),
  actions: {
    setLocale(locale) {
      i18n.global.locale.value = locale
      this.currentLocale = locale
      const talent = document.querySelector('.talent')
      if (talent) {
        talent.setAttribute('lang', locale)
      }
    }
  }
})
